export default __webpack_public_path__ + "static/media/mission.ddd02e00.jpeg";